import "./style.css";

import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

function DialogModal({ onClose, opened, title, children, buttonLabel }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={opened}
      className="boxModal"
      onBackdropClick={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className="title">{title}</DialogTitle>
      <DialogContent className="boxModal">{children}</DialogContent>
      <DialogActions>
        <div className="single button boxModal">
          <Button onClick={onClose} color="primary" autoFocus>
            {buttonLabel || t("BTN_OK")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default DialogModal;
